'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider.state('main', {
    url: '/',
    template: '<main></main>'
  });
}];
